import { createContext, useContext, useState } from "react";

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [isDark, setIsDark] = useState(true);
  const toggleTheme = () => setIsDark((prev) => !prev);
  return (
    <ThemeContext.Provider value={{ isDark, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);

// ── THEME ───
export const DARK = {
  bg: "#0d1117",
  bgAlt: "#161b22",
  border: "#21262d",
  borderHover: "#58a6ff55",
  text: "#e6edf3",
  textSub: "#8b949e",
  textMuted: "#c9d1d9",
  accent: "#58a6ff",
  accentPurple: "#a371f7",
  accentGreen: "#3fb950",
  accentOrange: "#f78166",
  accentYellow: "#e9c97fff",
  navBg: "rgba(13,17,23,0.92)",
  badgeBg: "#1f6feb22",
  badgeBorder: "#1f6feb55",
  badgeColor: "#58a6ff",
  tagBg: "#21262d",
  tagBorder: "#30363d",
  tagColor: "#c9d1d9",
  toggleBg: "#21262d",
  toggleIcon: "☀️",
  toggleLabel: "Light",
  divider: "#21262d",
  shadow: "0 2px 12px rgba(0,0,0,0.4)",
};

export const LIGHT = {
  bg: "#f6f8fa",
  bgAlt: "#ffffff",
  border: "#d0d7de",
  borderHover: "#0969da55",
  text: "#1f2328",
  textSub: "#656d76",
  textMuted: "#424a53",
  accent: "#0969da",
  accentPurple: "#8250df",
  accentGreen: "#1a7f37",
  accentOrange: "#cf222e",
  accentYellow: "#9a6700",
  navBg: "rgba(246,248,250,0.95)",
  badgeBg: "#ddf4ff",
  badgeBorder: "#54aeff66",
  badgeColor: "#0969da",
  tagBg: "#eef1f4",
  tagBorder: "#d0d7de",
  tagColor: "#424a53",
  toggleBg: "#e6edf3",
  toggleIcon: "🌙",
  toggleLabel: "Dark",
  divider: "#d0d7de",
  shadow: "0 2px 12px rgba(0,0,0,0.08)",
};
